export default __webpack_public_path__ + "static/media/icons8-sand-watch.a2b615ed.svg";